import React from 'react'
import './ProgressTimeout.css'

const ProgressTimeout = ({millis}) => {
  return (
    <div className='progressTimeout' style={{animationDuration: `${millis}ms`}} />
  )
}

export default React.memo(ProgressTimeout);
